import i18n from 'i18next';

type MemoizedNumberFormats = {
  [index: string]: {
    format(value: number): string;
  };
};

type options = {
  roundDown?: boolean;
  wholeNumber?: boolean;
};

export const memoizeNumberFormatter: MemoizedNumberFormats = {};

const parseCurrency = (
  currencyCode: string,
  value: number,
  options?: options,
): string => {
  const decimalPlaces = options?.wholeNumber
    ? {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    : {};
  const valueToFormat = options?.roundDown ? Math.floor(value) : value;

  const locale = i18n.language;
  const optionsString = options
    ? `_${options.roundDown}_${options.wholeNumber}`
    : '';
  if (!memoizeNumberFormatter[`${locale}_${currencyCode}${optionsString}`]) {
    memoizeNumberFormatter[
      `${locale}_${currencyCode}${optionsString}`
    ] = Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      ...decimalPlaces,
    });
  }

  return memoizeNumberFormatter[
    `${locale}_${currencyCode}${optionsString}`
  ].format(valueToFormat);
};

export default parseCurrency;
